<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      黄田站<br>
站点介绍<br>
1.1.1 黄田站位于广深公路与凯成二路交叉口，沿广深公路敷设。共设置了2个出入口（C、D）、3个风亭组、3个紧急疏散通道。车站2个出入口，均沿广深公路南方向布置。C号出入口位于深圳市新斩达实业有限公司正前方，为备用紧急出入口,同时设垂直电梯，宽7.5米。D出入口为公交接驳口，周边主要分布了广宇工业园、下洋贝工业区、光汇工业园、东望洋工业区、黄田村等多个工业园及居民区,客流较为集中，片区出行需求量较大。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:04	23:44	12号线	4分钟	8分钟<br>
海上田园东	06:05	23:27	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:04	23:44	12号线	8分钟	8分钟<br>
海上田园东	06:03	23:27	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
C出入口:<br>
广深公路南侧、宝安市场监督管理局黄田所、黄田公园、航城街道办事处、黄田小学、深圳市宝安区中心医院航城社区医院D出入口<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 航城街道办<br>
M246、M511<br><br>
D出入口:<br>
公交站名： 黄田1<br>
M335、337、高峰专线56号、727、M395、629、M413、M350、E16、B836、362、M531、M435、M246、M511、高快巴士29路<br><br>
D出入口:<br>
公交站名： 黄田2<br>
331、629路大站快车<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>